const SESSION_TIMEOUT = 30 * 60 * 1000;

export const saveSession = (token, user) => {
  localStorage.setItem('userToken', token);

  if (user) {
    localStorage.setItem('userInfo', JSON.stringify(user));
  }

  localStorage.removeItem('lastActiveAt');
};

export const clearSession = () => {
  localStorage.removeItem('userToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('lastActiveAt');
};

export const getUser = () => {
  try {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('userToken');

  if (!token) return false;

  const lastActiveAt = localStorage.getItem('lastActiveAt');

  if (lastActiveAt) {
    const diff = Date.now() - Number(lastActiveAt);

    if (diff > SESSION_TIMEOUT) {
      clearSession();
      return false;
    }
  }

  return true;
};

export const markInactive = () => {
  localStorage.setItem('lastActiveAt', Date.now().toString());
};

export const markActive = () => {
  const lastActiveAt = localStorage.getItem('lastActiveAt');

  if (!lastActiveAt) return true;

  const diff = Date.now() - Number(lastActiveAt);

  if (diff > SESSION_TIMEOUT) {
    clearSession();
    return false;
  }

  localStorage.removeItem('lastActiveAt');
  return true;
};